import React, { useState, useEffect } from 'react';
import { matchPath } from 'react-router-dom';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import { Button, ButtonGroup, Icon } from 'ui';
import Notice, { NOTICE_TYPES } from 'ui/Notice/Notice';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';

const match = () =>
  matchPath(window.location.pathname, { path: '/lessons/:lessonId' });

const LessonTemplateModal = ({ closeModal, fromLesson = false }) => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
  });
  const [lessonDetails, setLessonDetails] = useState({
    isScorm: false,
    lessonId: null,
  });

  useEffect(() => {
    if (fromLesson) {
      const id = match()?.params?.lessonId;
      request.get(routes.LESSON_OVERVIEW.INDEX(id)).then(data => {
        const { title, description, id: lessonId, scorm: isScorm } = data;

        setFormData({ title, description });
        setLessonDetails({ isScorm, lessonId });
      });
    }
  }, [fromLesson]);

  const preventLineBreaks = e => {
    if (e.key === 'Enter') e.preventDefault();
  };

  const handleInputChange = e => {
    const { name } = e.target;
    let { value } = e.target;

    if (name === 'description') {
      value = value.replace(/\r?\n|\r/g, ' ');
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const createTemplateFromLesson = async (title, description, lessonId) => {
    await request.postJSON(routes.CREATE_TEMPLATE_FROM_LESSON, {
      lesson_id: lessonId,
      title,
      description,
    });

    closeModal();
    request.getScript(routes.NOTIFICATIONS_LATEST);
  };

  const createTemplate = async (title, description) => {
    const data = await request.postJSON(routes.CREATE_TEMPLATE, {
      title,
      description,
    });

    window.location.assign(routes.EDIT_TEMPLATE(data.id));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const { title, description } = formData;
    const { lessonId } = lessonDetails;
    if (fromLesson) {
      createTemplateFromLesson(title, description, lessonId);
    } else {
      createTemplate(title, description);
    }
  };

  return (
    <RenderInBody>
      <ModalContainer
        className="ModalTakeover-background Modal-background d-f ai-c"
        onEscape={closeModal}
      >
        <div className="ModalTakeover-container TemplateCreationModal">
          <div className="TemplateCreationModal-body">
            <form onSubmit={handleSubmit}>
              <div className="TemplateCreationModal-title">
                {fromLesson
                  ? t(
                      'contents.library.template_library.create_modal.create_from_lesson_title',
                    )
                  : t('contents.library.template_library.new_template')}
              </div>
              <div className="TemplateCreationModal-subtitle">
                {t(
                  'contents.library.template_library.create_modal.description',
                )}
              </div>
              {lessonDetails.isScorm && (
                <div className="TemplateCreationModal-scormNotice">
                  <Notice
                    iconName="alert"
                    type={NOTICE_TYPES.INFO}
                    bodyText={t(
                      'contents.library.template_library.create_modal.scorm_warning',
                    )}
                  />
                </div>
              )}
              <label
                htmlFor="title"
                className="TemplateCreationModal-inputTitle"
              >
                {t('common.title')}
              </label>
              <input
                id="title"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                className="NewInput NewInput--white NewInput--fw ModalTakeover-nameInput"
                placeholder={t('common.enter_title')}
                type="text"
                maxLength="255"
              />
              <label
                htmlFor="description"
                className="TemplateCreationModal-inputTitle"
              >
                {t('common.description')}
              </label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                className="NewInput NewInput--white NewInput--fw"
                placeholder={t(
                  'contents.library.template_library.create_modal.enter_description',
                )}
                rows="6"
                onKeyDown={preventLineBreaks}
              />
              <ButtonGroup alignEnd className="mt-32">
                <Button
                  type="submit"
                  className="TemplateCreationModal-submitButton"
                >
                  {t(
                    'contents.library.template_library.create_modal.create_template',
                  )}
                </Button>
              </ButtonGroup>
            </form>

            <button
              type="button"
              name="close_modal"
              className="u-resetBtn ModalTakeover-closeButton"
              aria-label={t('common.close')}
              onClick={closeModal}
            >
              <Icon name="error" />
            </button>
          </div>
        </div>
      </ModalContainer>
    </RenderInBody>
  );
};

export default LessonTemplateModal;
